import * as React from 'react';

import { SliderContext } from '../context';

export const useSlider = () => {
  const { setSlider, swiper, activeSlide, resetSlider, setActiveSlide } =
    React.useContext(SliderContext);
  return {
    setSlider,
    swiper,
    activeSlide,
    setActiveSlide,
    resetSlider,
  };
};
